var _path, _path2, _circle, _g, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_5873503",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64 0a64 64 0 1 0 64 64 64.005 64.005 0 0 0 -64-64zm0 116.825a52.825 52.825 0 1 1 52.825-52.825 52.882 52.882 0 0 1 -52.825 52.825z",
    fill: "#ef6060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m128 64a64.022 64.022 0 0 1 -94.5 56.28 64.016 64.016 0 0 0 57.09-114.51 64.029 64.029 0 0 1 37.41 58.23z",
    opacity: 0.08
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.996,
    cy: 64,
    fill: "#e1e6ea",
    r: 52.825
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b9c2d2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64 25.1a1.015 1.015 0 0 1 -1.015-1.016v-4.684a1.016 1.016 0 1 1 2.031 0v4.683a1.015 1.015 0 0 1 -1.016 1.017z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.773 36.793a1.013 1.013 0 0 1 -.718-.3l-3.311-3.311a1.016 1.016 0 0 1 1.436-1.437l3.312 3.312a1.016 1.016 0 0 1 -.719 1.734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.081 65.02h-4.681a1.016 1.016 0 0 1 0-2.032h4.683a1.016 1.016 0 1 1 0 2.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.462 96.559a1.017 1.017 0 0 1 -.718-1.735l3.311-3.311a1.016 1.016 0 1 1 1.437 1.436l-3.312 3.312a1.013 1.013 0 0 1 -.718.298z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 109.622a1.015 1.015 0 0 1 -1.016-1.016v-4.683a1.016 1.016 0 1 1 2.031 0v4.683a1.015 1.015 0 0 1 -1.015 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.538 96.559a1.013 1.013 0 0 1 -.718-.3l-3.312-3.312a1.016 1.016 0 1 1 1.437-1.436l3.311 3.311a1.017 1.017 0 0 1 -.718 1.735z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.6 65.02h-4.683a1.016 1.016 0 0 1 0-2.032h4.683a1.016 1.016 0 0 1 0 2.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.227 36.793a1.016 1.016 0 0 1 -.719-1.734l3.312-3.312a1.016 1.016 0 0 1 1.436 1.437l-3.311 3.311a1.013 1.013 0 0 1 -.718.298z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m64 59.534a1.015 1.015 0 0 1 -1.015-1.016v-12.8a1.016 1.016 0 1 1 2.031 0v12.8a1.016 1.016 0 0 1 -1.016 1.016z",
    fill: "#2b375c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m94.522 65.02h-25.036a1.016 1.016 0 0 1 0-2.032h25.036a1.016 1.016 0 0 1 0 2.032z",
    fill: "#2b375c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m70.5 64a6.5 6.5 0 1 1 -6.5-6.5 6.5 6.5 0 0 1 6.5 6.5z",
    fill: "#a1a9b5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d447dd10385268a7706986af2e7c5fff.svg";
export { ForwardRef as ReactComponent };